export default {
  heading: 'Restore Password',
  invalidCode: 'Email code is invalid',
  subhead: 'Enter the authentication code we sent to {{email}}.',
  submit: 'Confirm',
};
